import api from './api';

export const createCompetition = async (competitionData) => {
  const response = await api.post('/competitions/', competitionData);
  return response.data;
};

export const getCompetitionsByProject = async (projectId) => {
  const response = await api.get(`/competitions/project/${projectId}`);
  return response.data;
};

export const getCompetitionById = async (competitionId) => {
  const response = await api.get(`/competitions/${competitionId}`);
  return response.data;
};

export const updateCompetition = async (competitionId, competitionData) => {
  const response = await api.put(`/competitions/${competitionId}`, competitionData);
  return response.data;
};

export const deleteCompetition = async (competitionId) => {
  const response = await api.delete(`/competitions/${competitionId}`);
  return response.data;
};